import { useQuery } from "@tanstack/react-query";
import { tenantService } from "@/services/tenantService";

export const useCompanyStatus = () => {
    const query = useQuery({
        queryKey: ["company-status"],
        queryFn: tenantService.getCompanyStatus,
        refetchInterval: 60000,
        retry: false,
    });

    const status = query.data?.status;
    const paymentGracePeriodEndsAt = query.data?.payment_grace_period_ends_at ?? null;

    return {
        ...query,
        isSuspended: status === "suspended",
        isPastDue: status === "past_due",
        isFreeTrial: query.data?.subscription_status === "free_trial",
        paymentGracePeriodEndsAt,
    };
};
